
import { Component, Vue } from "vue-property-decorator";
import { SMQuestionnaire } from "@/store";
import QuestionnaireSidebarStep from "./QuestionnaireSidebarStep.vue";

@Component({
  components: {
    QuestionnaireSidebarStep,
  },
})
export default class QuestionnaireSidebar extends Vue {
  get stages() {
    return SMQuestionnaire.stages;
  }

  get currentStage() {
    if (SMQuestionnaire.currentStep == null) return { index: 0 };

    return SMQuestionnaire.currentStep?.stage;
  }
}
